<div
  class="company-block-card"
  [ngClass]="{
    'company-block-card-full-height': isFullHeight,
    'company-block-card-margin-top': isMarginTop,
    'company-block-card-margin-bottom': isMarginBottom
  }"
>
  <div class="company-block-card-header">
    <div class="company-block-card-header-title-wrapper">
      <h3 class="company-block-card-header-title">{{ isTitleTranslatable ? (title | translate) : title }}</h3>
      <span [class]="'company-block-card-header-tag' + ' ' + tagType" *ngIf="tag">
        {{ isTagTranslatable ? (tag | translate | uppercase) : (tag | uppercase) }}
      </span>
      <div class="company-block-card-header-hint" *ngIf="hint">
        <app-hint-tooltip-icon [hint]="hint | translate"></app-hint-tooltip-icon>
      </div>

      <span class="company-block-card-header-required" *ngIf="isShowRequired">{{ "LABELS.REQUIRED" | translate }}</span>
      <span class="company-block-card-header-optional" *ngIf="isShowOptional">{{ "LABELS.OPTIONAL" | translate }}</span>
    </div>

    <ng-content select="[card-actions]"></ng-content>
  </div>

  <div class="company-block-card-body">
    <div class="company-block-card-body-explanation" *ngIf="explanationTitle || explanationSubTitle">
      <div class="company-block-card-body-explanation-title" [innerHTML]="explanationTitle | translate"></div>
      <div class="company-block-card-body-explanation-sub-title" [innerHTML]="explanationSubTitle | translate"></div>
    </div>

    <div class="company-block-card-body-content">
      <ng-content select="[card-body]"></ng-content>
    </div>
  </div>
</div>
